
import "C:/github-runners/esig-portal/_work/esig-client/esig-client/src/layout/Header/RightContent/index.less?modules";
export default {"search": `search-P7zkBFfK`,"account": `account-kboOUrgR`,"avatar": `avatar-tQw2SGdo`,"name": `name-SVo8izGB`,"menu": `menu-f_Y_u64l`,"right": `right-cuGQjcWX`,"action": `action-21AxYXi7`}
